import AdminPanel from "../../../components/admin-panel"



export default function AdminPanelPage() {
  return (
    <AdminPanel />
  )
}